import { render, staticRenderFns } from "./configuration-assays-groups-grid.vue?vue&type=template&id=5a1b791b&scoped=true&"
import script from "./configuration-assays-groups-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-assays-groups-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-assays-groups-grid.scss?vue&type=style&index=0&id=5a1b791b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b791b",
  null
  
)

export default component.exports